export interface AssignCase {
  userId: string;
  caseIds: string[];
}

export interface CreateCaseRequest {
  provider: string;
  clinic: string;
  accommodation: string;
  company: string;
  caseCode: string;
  providerCaseCode: number;
  dateAdmitted: Date;
  dateDischarged: Date;
  duration: number;
  contractType: string;
  contractCode: string;
  admissionReason: string;
  admissionIcd10Code: string;
  admissionIcd10Desc: string;
  dischargedIcd10Code: string;
  dischargedIcd10Desc: string;
  ken: string;
  caseType: string;
  emergencyHosp: string;
  plannedHosp: string;
  continuingHosp: string;
  accident: string;
  congenitalDisease: string;
  outpatient: string;
  cosmeticSurgery: string;
  admissionReasonDetailed: string;
  incident: string;
  surgeryDesc: string;
  interventionSpecialty: string;
  interventionSeverity: string;
  multipleSurgeries: string;
  hospitalizationOutcome: string;
  medicalSupDetax: number;
  specialMedicalSupDetax: number;
  medicinesDetax: number;
  hospDetax: number;
  medExamsDetax: number;
  surgeryDetax: number;
  narcosisDetax: number;
  otherDetax: number;
  doctorFeesInDetax: number;
  eopyy: number;
  insured: number;
  incidentNumber: number;
  proformalPriceAfterTax: number;
  doctorFeesOutAfterTax: number;
  totalPriceAfterTax: number;
  priceBilledAfterTax: number;
  invoice: Invoice[];
}

export interface Invoice {
  invoiceId: string;
  code: string;
  description: string;
  itemDate: Date;
  quantity: number;
  itemPriceTotal: number;
  itemPriceInsurance: number;
  itemPriceEOPYY: number;
  itemPriceIdiotis: number;
}

export interface ProccessedCoassessCase {
  caseId: string;
  started: Date | null;
  caseManager?: string;
  investigator: string;
  incidentType: string;
  anomalyDetection: string;
  costEstimator: string;
  caseSeverity: string;
  isNewCase: boolean;
  investigationResults: string;
  isViewedByCurrentUser?: boolean;
}
export interface ProccessedCoreactCase {
  caseId: string;
  started: Date;
  fraudScore: string;
  modelResult: string;
  incidentProfile: string;
  unsupervisedScore: string;
  imageSimilarityScore: string;
  modelResultCharacerization: string;
  totalClaimAmount: number;
  caseSeverity: string;
  priorityIndex: number;
  systemResult: 'Suspicious' | 'NotSuspicious';
  investigationResults: string;
  investigator: string;
  isNewCase: boolean;
  isViewedByCurrentUser: boolean;
  severity: string;
}


export interface CaseFilterRequest {
  systemResult?: string;
  claimNumber?: string;
  insuranceReponse?: string;
  adjuster?: string;
  licensePlate?: string;
  minAge?: number;
  maxAge?: number;
  minimumPriorityIndex?: number;
  maximumPriorityIndex?: number;
  fromDate?: string;
  toDate?: string;
  caseStatus?: string;
  claimStatus?: string;
  hospitalName?: string;
  pageNumber: number;
  pageSize: number;
  sortBy?: string;
  sortDesc?: boolean;
};

export interface ModelMetricDto {
  modelName: string;
  version: string;
  accuracy?: number;
  precision?: number;
  recall?: number;
  f1Score?: number;
  meanAbsoluteError?: number;
  rootMeanSquaredError?: number;
  rSquared?: number;
  rocAreaUnderCurve?: number;
  trainingDate?: string;
  deploymentDate?: string;
}
